import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { createMarkup } from '../../utils';
import { Typography } from '../Typography';

interface DataVisualPanelProps {
  children: any;
  heading?: string;
  source?: string;
  control?: any;
}

interface StyledHeaderProps {
  hasControl: boolean;
}

const StyledDataVisualPanel = styled.div`
  ${({ theme: { space } }) => css`
    /* ... */
  `};
`;

const StyledHeader = styled.div<StyledHeaderProps>`
  ${({ theme: { space, media }, hasControl }) => css`
    margin-bottom: ${space.md};

    ${hasControl &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${space.lg};
    `}

    // Tablet > styles

    @media (min-width: ${media.md}) {
      margin-bottom: ${space.lg};

      ${hasControl &&
      css`
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        gap: ${space.xl};
      `}
    }
  `};
`;

const StyledHeading = styled(Typography)`
  max-width: 450px;
`;

const StyledSource = styled(Typography)`
  ${({ theme: { space } }) => css`
    margin-top: ${space.sm};
  `};
`;

export const DataVisualPanel: FC<DataVisualPanelProps> = ({ heading, source, children, control, ...rest }) => (
  <StyledDataVisualPanel {...rest}>
    {heading || source || control ? (
      <StyledHeader hasControl={!!control}>
        {heading || source ? (
          <div>
            {heading && (
              <StyledHeading component="h3" variant="titleMedium">
                {createMarkup(heading)}
              </StyledHeading>
            )}
            {source && (
              <StyledSource component="small" variant="bodySmall">
                Source - {source}
              </StyledSource>
            )}
          </div>
        ) : (
          ''
        )}
        {control && control}
      </StyledHeader>
    ) : (
      ''
    )}

    {children}
  </StyledDataVisualPanel>
);
